import { render, staticRenderFns } from "./brand-banner.vue?vue&type=template&id=653539f4&"
import script from "./brand-banner.vue?vue&type=script&lang=js&"
export * from "./brand-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports